import { render, staticRenderFns } from "./FacialFeaturesTemplate.vue?vue&type=template&id=0e540fab&scoped=true"
import script from "./FacialFeaturesTemplate.vue?vue&type=script&lang=js"
export * from "./FacialFeaturesTemplate.vue?vue&type=script&lang=js"
import style0 from "./FacialFeaturesTemplate.vue?vue&type=style&index=0&id=0e540fab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e540fab",
  null
  
)

export default component.exports